import { FormActualResidenceVM } from 'practice/view-models/pratice-actual-residence';
import { CadastralData } from 'shell/models/person';
import { Residence } from 'shell/models/person/residence';
import { CirculationAreaClient } from 'shell/view-models/circulation-area-client';
import { ItalianVM } from 'shell/view-models/register-office-practice-vm';

export const transformActualResidencePractice = (
  residence?: Residence,
  datiCatastali?: CadastralData,
  isHomeless?: boolean
): FormActualResidenceVM => {
  return {
    checkedResidence: !!residence?.localitaEstera?.indirizzoEstero,
    foreign: residence?.localitaEstera?.indirizzoEstero
      ? {
          address: residence?.localitaEstera?.indirizzoEstero?.toponimo?.denominazione,
          cap: residence?.localitaEstera?.indirizzoEstero?.cap,
          nationCode: residence?.localitaEstera?.indirizzoEstero?.localita?.codiceStato,
          civicNumber:
            residence?.localitaEstera?.indirizzoEstero?.toponimo?.numeroCivico?.toString(),
          foreignState: residence?.localitaEstera?.indirizzoEstero?.localita
            ? {
                id: residence?.localitaEstera?.indirizzoEstero?.localita?.codiceStato || '',
                value: residence?.localitaEstera?.indirizzoEstero?.localita?.descrizioneStato || '',
                province:
                  residence?.localitaEstera?.indirizzoEstero?.localita?.provinciaContea || '',
              }
            : undefined,
          municipality: residence?.localitaEstera?.indirizzoEstero?.localita
            ? {
                id: residence?.localitaEstera?.indirizzoEstero?.localita?.codiceStato || '',
                description:
                  residence?.localitaEstera?.indirizzoEstero?.localita?.descrizioneLocalita || '',
                province:
                  residence?.localitaEstera?.indirizzoEstero?.localita?.provinciaContea || '',
              }
            : undefined,
          consulateCode: residence?.localitaEstera?.consolato
            ? {
                id: residence?.localitaEstera?.consolato?.codiceConsolato
                  ? Number.parseInt(residence?.localitaEstera?.consolato?.codiceConsolato, 10)
                  : '',
                value: residence?.localitaEstera?.consolato?.descrizioneConsolato || '',
              }
            : undefined,
          territory: residence.localitaEstera.indirizzoEstero?.localita?.codiceStato
            ? {
                id: Number.parseInt(
                  residence.localitaEstera.indirizzoEstero?.localita?.codiceStato,
                  10
                ),
                value: residence.localitaEstera.indirizzoEstero?.localita?.descrizioneStato || '',
              }
            : undefined,
        }
      : undefined,
    italian: residence?.indirizzo
      ? ({
          address: residence?.indirizzo?.toponimo?.denominazioneToponimo
            ? ({
                code: 0,
                description: residence?.indirizzo?.toponimo?.denominazioneToponimo || '',
              } as CirculationAreaClient)
            : null,
          number: residence?.indirizzo?.numeroCivico?.numero || undefined,
          exponent: residence?.indirizzo?.numeroCivico?.esponente1 || '',
          letter: residence?.indirizzo?.numeroCivico?.lettera || '',
          cap: residence?.indirizzo?.cap || '',
          municipality: residence?.indirizzo?.comune
            ? {
                id: residence?.indirizzo?.comune?.codiceIstat || '',
                description: residence?.indirizzo?.comune?.nomeComune || '',
                province: residence?.indirizzo?.comune?.siglaProvinciaIstat || '',
                istatCode: residence?.indirizzo?.comune?.codiceIstat || '',
              }
            : undefined,
          descrizioneSpecieToponimo: residence?.indirizzo?.toponimo?.specie || '',
          codTipoVia: residence?.indirizzo?.toponimo?.codSpecie || '',
          section: datiCatastali?.sezione || '',
          particle: datiCatastali?.particella || '',
          sheet: datiCatastali?.foglio || '',
          sub: datiCatastali?.subalterno || '',
          cat: datiCatastali?.categoriaCatastale || '',
          isHomeless,
          isCadastralObjectEmpty:
            (datiCatastali === null && !isHomeless) ||
            (datiCatastali?.particella === null &&
              datiCatastali?.foglio === null &&
              datiCatastali?.subalterno === null &&
              !isHomeless),
        } as ItalianVM)
      : undefined,
  };
};
